import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from '../../shared/api/application-http-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TutorialSessionQuestionService {

  constructor(private httpClient: ApplicationHttpClient) { }

  getTutorialSessionQuestion(id: string): Observable<any> {
    return this.httpClient.get(`/tutorial-session/questions/${ id }`);
  }
}
